import {
    connect
} from 'react-redux'
import view from './view'
import {
    openSetting,
    setMenuStatus,
    goHomePage
} from './action'
import {
    loadContent
} from '../popup/action'

const stateToProps = (state) => {
    return {
        ...state.menu,
        nav_isCollapseNav: state.nav.isCollapseNav,
        setting_isWidescreenOn: state.setting.isWidescreenOn
    }
};
const actionToProps = {
    openSetting,
    setMenuStatus,
    goHomePage,
    loadContent

};

export default connect(stateToProps, actionToProps)(view);